
import React from "react";
import { FishingDiscipline } from "../../types/fishingDiscipline";
import armeriaSollevanti from "../../assets/sponsors/armeria-sollevanti.png";

const sponsorImages = [
  "/images/sponsors/sponsor-1.jpeg",
  "/images/sponsors/sponsor-2.jpeg",
  "/images/sponsors/sponsor-3.jpeg"
];


const Sponsors: React.FC<{ discipline: FishingDiscipline }> = ({ discipline }) => {
  const carp = discipline === FishingDiscipline.CarpAndCrucian;
  const images = carp
    ? [{ src: armeriaSollevanti, alt: "Armeria Sollevanti, sponsor del campionato Carpe e Carassi" }]
    : sponsorImages.map((src, idx) => ({ src, alt: `Sponsor ${idx + 1}` }));

  return (
    <section className="site-sponsors" aria-label={carp ? "Il nostro sponsor" : "I nostri sponsor"}>
      <h2>{carp ? "Il nostro sponsor" : "I nostri sponsor"}</h2>
      <div className={`site-sponsors__logos ${carp ? "site-sponsors__logos--carp" : ""}`}>
        {images.map(({ src, alt }) => (
          <img key={src} src={src} alt={alt} loading="lazy" />
        ))}
      </div>
    </section>
  );
};

export default Sponsors;
